import React from "react";
import { useTheme } from "@mui/material/styles";
import dayLogo from "../../assets/images/Logo smart farm1.jpg";

export default function SmartFarmLogo({ alt = "SmartFarm", ...props }) {
  const theme = useTheme();
  const src = theme.palette.mode === "dark"
    ? `${process.env.PUBLIC_URL || ""}/logo_nuit.png`
    : dayLogo;
  return <img {...props} src={src} alt={alt} />;
}
